<input type="checkbox" class="openSidebarMenu isMobile" id="openSidebarMenu">
<label for="openSidebarMenu" class="sidebarIconToggle spinner-main" (click)="toggleState()">
    <div class="spinner diagonal part-1"></div>
    <div class="spinner horizontal"></div>
    <div class="spinner diagonal part-2"></div>
</label>
<div class="sidebarMenu" [ngClass]="{ 'in': isIn }">
    <nav id="navigation-menu" class="navbar-default navbar-static-side">
        <div class="sidebar-collapse">
            <div class="logo-box">
                <div class="logo"></div>
            </div>
            <div class="nav-filter" *ngIf="!authenticationService.userIsResident">
                <div class="input-group search-field" *ngIf="!showSettingsSideMenu">
                    <quick-search></quick-search>
                </div>
            </div>
            <ul *ngIf="allowedListData.length && !showSettingsSideMenu && authenticationService.userIsResident" class="nav resident-nav">
                <li routerLinkActive="active_menu" (click)="toggleState()" [ngClass]="{'active-link': isActiveLink('/home')}">
                    <a (click)="navigateTo('/home')">
                        <span class="nav-label">Home</span>
                    </a>
                </li>
                <li *ngIf="accessForMenu('email_merge')"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/email-merge')}">
                    <a (click)="navigateTo('/email-merge')">
                        <span class="nav-label">Inbox</span>
                    </a>
                </li>
                <li *ngIf="accessForMenu('parking_pass')"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/parking_passes')}">
                    <a (click)="navigateTo('/parking_passes')">
                        <span class="nav-label">Parking Passes</span>
                    </a>
                </li>
                <li *ngIf="accessForMenu('amenity')"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/amenities')}">
                    <a (click)="navigateTo('/amenities')">
                        <span class="nav-label">Amenities</span>
                    </a>
                </li>
                <li [ngClass]="{'active-link': isActiveLink('/service-request')}"
                    (click)="toggleState()"
                    *ngIf="accessForMenu('service_request') && residentService.allowedForResident('service_request')">
                    <a (click)="navigateTo('/service-request', true)">
                        <span class="nav-label">Service Request</span>
                    </a>
                </li>
                <li *ngIf="accessForMenu('parcels')"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/parcels')}">
                    <a (click)="navigateTo('/parcels', true)">
                        <span class="nav-label">Parcels</span>
                    </a>
                </li>
                <li *ngIf="!!residentService?.selectedBuilding?.cNSettings?.useResidentInstruction"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/front-desk-instructions')}">
                    <a (click)="navigateTo('/front-desk-instructions')">
                        <span class="nav-label">Front Desk Instructions</span>
                    </a>
                </li>
                <li *ngIf="accessForMenu('documents')"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/documents')}">
                    <a (click)="navigateTo('/documents')">
                        <span class="nav-label">Documents</span>
                    </a>
                </li>
                <li *ngIf="condomanagerService.isHasEntries"
                    (click)="toggleState()"
                    [ngClass]="{'active-link': isActiveLink('/account-statement')}">
                    <a (click)="navigateTo('/account-statement')">
                        <span class="nav-label">Account Statement</span>
                    </a>
                </li>
<!--	        <li routerLinkActive="active_menu" *ngIf="isServiceAvailable('community')">-->
<!--		        <a routerLink="/community">-->
<!--			        <span class="nav-label">Community</span>-->
<!--		        </a>-->
<!--	        </li>-->
                <li routerLinkActive="active_menu" *ngIf="noticePmiUrl">
                    <a [href]="noticePmiUrl" target="_blank">
                        <span class="nav-label">Notices</span>
                    </a>
                </li>
                <li *ngIf="residentService.selectedBuilding?.contactUs"
                    (click)="residentService.contactUsModalShow = true">
                    <a>
                        <span class="nav-label">Contacts</span>
                    </a>
                </li>
            </ul>

            <ul *ngIf="!authenticationService.userIsResident && allowedListData.length && !showSettingsSideMenu"
                class="nav metismenu"
                id="side-menu">
                <li routerLinkActive="active_menu"
                    (click)="toggleState()"
                    [ngClass]="{'active-group': isHomeActive()}">
                    <mat-divider></mat-divider>
                    <a (click)="navigateTo('/home')">
                        <i class="fa fa-bar-chart" aria-hidden="true"></i>
                        <span class="nav-label">Home</span>
                    </a>
                </li>
                <li *ngFor="let item of allowedListData let last = last;" [ngStyle]="{'border': item.maxTv ? 'none' : ''}">
                    <mat-divider *ngIf="!item.maxTv"></mat-divider>
                    <mat-accordion *ngIf="!item.maxTv && !item.settings">
                        <mat-expansion-panel [hideToggle]="true" [@.disabled]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title [ngClass]="{'active-group': item.isGroupActive}">
                                    <div class="nav-image-svg"
                                         [ngStyle]="{'mask-image': 'url(/assets/img/nav-icons/' + item.icon + ')',
                                                     '-webkit-mask-image': 'url(/assets/img/nav-icons/' + item.icon + ')'}">
                                    </div>
                                    <span class="nav-label">{{item.groupTitle}}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul *ngIf="!item.maxTv && !item.settings" class="nav nav-second-level">
                                <li *ngFor="let link of item.links"
                                    (click)="toggleState()"
                                    [ngClass]="{'active-link': isActiveLink(link.route)}">
                                    <a (click)="navigateTo(link.route, true)">
                                        <span class="nav-label">{{link.title}}</span>
                                    </a>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <a *ngIf="item.maxTv && isMaxTvLinkAvailable" (click)="goToMaxTv()" [ngClass]="{'disabled': isLinkLoading}">
                        <span class="nav-label">{{item.groupTitle}}</span>
                        <spinner [spinnerShow]="isLinkLoading"></spinner>
                    </a>
                    <a *ngIf="item.settings" (click)="goToSettings()">
                        <div class="nav-image-svg"
                             [ngStyle]="{'mask-image': 'url(/assets/img/nav-icons/' + item.icon + ')',
                                         '-webkit-mask-image': 'url(/assets/img/nav-icons/' + item.icon + ')'}">
                        </div>
                        <span class="nav-label">{{item.groupTitle}}</span>
                    </a>
                </li>
            </ul>

            <div *ngIf="showSettingsSideMenu" class="settings-nav-header">
                <i class="fa fa-arrow-left" aria-hidden="true" (click)="goBackFromSettings()"></i>
                <div>Settings</div>
            </div>
            <ul *ngIf="showSettingsSideMenu && allowedListData.length" class="nav metismenu settings-side-menu" id="settings-side-menu">
                <li [ngClass]="{'active-link': isActiveLink(settingsItem.route)}"
                    routerLinkActive="active"
                    *ngFor="let settingsItem of allowedListData[allowedListData.length - 1].links">
                    <a (click)="navigateTo(settingsItem.route)">
                        <span class="nav-label">{{settingsItem.title}}</span>
                    </a>
                </li>
            </ul>

            <div class="profile-element" (click)="toggleProfileActions()">
                <div *ngIf="isProfileActionsShow" class="profile-actions animated fadeIn">
                    <ul>
                        <li *ngFor="let building of buildings"
                            [class.active_menu]="building.residentBdId === selected.residentBdId && building.suiteNumber === selected.suiteNumber"
                            class="select_building"
                            (click)="onSelectBuilding(building)">
                            <span>{{building.buildingName}} - {{building.suiteNumber}}</span>
                        </li>
                        <li (click)="toggleState()">
                            <a [routerLink]="['/profile']">
                                <span class="nav-label">My Profile</span>
                            </a>
                        </li>
                        <li>
                            <a (click)="logoutWithRedirect()">
                                <span class="nav-label">Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="username-wrapper">
                    <img class="img-circle"
                         *ngIf="(authenticationService.userIsResident ? residentService.selectedBuilding?.residentPhoto : accountService.user?.avatar)"
                         [src]="(authenticationService.userIsResident ? residentService.selectedBuilding?.residentPhoto : accountService.user?.avatar)">
                    <div class="img-placeholder"
                         *ngIf="!(authenticationService.userIsResident ? residentService.selectedBuilding?.residentPhoto : accountService.user?.avatar)">
                    </div>
                    <div class="font-bold username">
                        {{authenticationService.userIsResident ? residentService.selectedBuilding.userName : accountService.user?.fullName}}
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="navigation-fade" (click)="toggleState()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/navigation/navigation.component.html